import { Component, Input } from '@angular/core';
import { Asset } from '../../interfaces/asset';
import { NgClass, NgIf } from '@angular/common';

import { ClrIconModule, ClrModalModule } from '@clr/angular';
import { ClarityIcons, trashIcon, heartIcon } from '@cds/core/icon';
import { FavoriteService } from '../../services/favorites.service';
@Component({
  selector: 'app-asset',
  standalone: true,
  imports: [NgIf, NgClass, ClrModalModule, ClrIconModule], // ClrIconModule hinzugefügt
  templateUrl: './asset.component.html',
  styleUrl: './asset.component.css',
})
export class AssetComponent {
  @Input('asset') asset: Asset | undefined;
  @Input('showTitle') showTitle: boolean = false;
  @Input('editMode') editMode: boolean = false;
  @Input('categoryName') categoryName: string = '';

  constructor(private favoriteService: FavoriteService) {
    ClarityIcons.addIcons(trashIcon, heartIcon);
  }

  get isFavorite(): boolean {
    if (!this.asset) return false;
    return this.favoriteService.isLiked(this.asset.id);
  }

  onHeartClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    if (!this.asset) return;

    const currentlyLiked = this.isFavorite;

    this.favoriteService
      .toggleFavorite(this.asset.id, !currentlyLiked)
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Fehler beim Speichern:', err);
          if (err.status === 409) {
            alert('Limit erreicht: Du kannst maximal 50 Favoriten speichern.');
          } else {
            alert('Ein Fehler ist aufgetreten.');
          }
        },
      });
  }
}
